"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5639],{

/***/ 35639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AuthContext": function() { return /* binding */ AuthContext; },
  "AuthProvider": function() { return /* binding */ AuthProvider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/configs/auth.js
/* harmony default export */ var auth = ({
    meEndpoint: "/auth/me",
    loginEndpoint: "/jwt/login",
    registerEndpoint: "/jwt/register",
    storageTokenKeyName: "accessToken",
    onTokenExpiration: "refreshToken" // logout | refreshToken
});

// EXTERNAL MODULE: ./src/utils/navigate.js
var utils_navigate = __webpack_require__(48551);
// EXTERNAL MODULE: ./src/utils/subscriptionExpire.js
var subscriptionExpire = __webpack_require__(96613);
// EXTERNAL MODULE: ./src/utils/resolveCurrentOrderId.js
var resolveCurrentOrderId = __webpack_require__(32870);
// EXTERNAL MODULE: ./src/utils/subscriptionStatus.js
var subscriptionStatus = __webpack_require__(38365);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
;// CONCATENATED MODULE: ./src/context/AuthContext.js
// ** React Imports


// ** Next Import

// ** Axios

// ** Config





const bUrl = (/* unused pure expression or super */ null && ("https://strapi.msafely.com"));
const clientURL = "https://msafely.com";
// ** Defaults
const defaultProvider = {
    user: null,
    loading: true,
    setUser: ()=>null,
    setLoading: ()=>Boolean,
    login: ()=>Promise.resolve(),
    logout: ()=>Promise.resolve(),
    register: ()=>Promise.resolve()
};
const AuthContext = /*#__PURE__*/ (0,react.createContext)(defaultProvider);
// request

const getParams = (url)=>{
    try {
        url = url.match(/\?([^#]+)/)[1];
        const obj = {};
        const arr = url.split("&");
        for(let i = 0; i < arr.length; i++){
            let subArr = arr[i].split("=");
            let key = decodeURIComponent(subArr[0]);
            let value = decodeURIComponent(subArr[1]);
            obj[key] = value;
        }
        return obj;
    } catch (err) {
        return null;
    }
};
const readJson = (key, fallback)=>{
    try {
        const raw = localStorage.getItem(key);
        if (raw == null || raw === "") return fallback;
        return JSON.parse(raw);
    } catch (e) {
        return fallback;
    }
};
const AuthProvider = (param)=>{
    let { children  } = param;
    // ** States
    const [user, setUser] = (0,react.useState)(defaultProvider.user);
    const [loading, setLoading] = (0,react.useState)(defaultProvider.loading);
    // ** Hooks
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const initAuth = async ()=>{
            try {
                const urlParams = getParams(location.search);
                let accessToken = window.localStorage.getItem(auth.storageTokenKeyName);
                if (urlParams != null) {
                    // 退出登录
                    if (urlParams.accessToken == "clear") {
                        window.localStorage.removeItem("userData");
                        window.localStorage.removeItem(auth.storageTokenKeyName);
                        localStorage.removeItem("Basic");
                        localStorage.removeItem("Advanced");
                        localStorage.removeItem("DeviceUser");
                        localStorage.removeItem("currentDevice", JSON.stringify({}));
                        (0,utils_navigate/* replaceWith */.dL)("".concat(clientURL, "/login?q=clear"));
                        return;
                    }
                    if (urlParams.accessToken && urlParams.accessToken != accessToken) {
                        localStorage.setItem("Basic", 0);
                        localStorage.setItem("Advanced", 0);
                        localStorage.setItem("DeviceUser", JSON.stringify({}));
                        localStorage.setItem("currentDevice", JSON.stringify({}));
                        window.localStorage.setItem(auth.storageTokenKeyName, urlParams.accessToken);
                    }
                } else if (accessToken == null) {
                    if (window.location.pathname.substring(1) === "user-guide-ios" || window.location.pathname.substring(1) === "user-guide-android" || window.location.pathname.substring(4) === "user-guide-ios" || window.location.pathname.substring(4) === "user-guide-android" || window.location.pathname.substring(1) === "back-up-android" || window.location.pathname.substring(1) === "back-up-ios" || window.location.pathname.substring(4) === "back-up-ios" || window.location.pathname.substring(4) === "back-up-android") {
                        (0,utils_navigate/* replaceWith */.dL)("".concat(clientURL, "/login?guide=").concat(encodeURIComponent("".concat(window.location.origin).concat(router.asPath))));
                        return;
                    }
                    (0,utils_navigate/* replaceWith */.dL)("".concat(clientURL, "/login"));
                }
                let token = window.localStorage.getItem(auth.storageTokenKeyName);
                if (!token) return;
                let user = await (0,login.getUserInfo)();
                let currentMode = localStorage.getItem("currentMode") || "";
                if (urlParams == null) {
                    try {
                        let { all , data  } = await (0,login.userDeviceCurrent)();
                        // 新号常见 { data: null, all: [null] }：有未绑定订单但 platform_type 为空。
                        // data != '' 对 null 仍为 true，会把 currentMode 设成 null，随后 indexOf 抛错卡死登录
                        // （main 的 14c20bc 修的就是这个；合并时把它并进本分支的重构版本）。
                        const modes = (Array.isArray(all) ? all : []).filter((m)=>m != null && m !== "");
                        const mode = data == null || data === "" ? "" : String(data);
                        if (mode) {
                            if (modes.length >= 2 && localStorage.getItem("currentMode") != null) {
                                currentMode = localStorage.getItem("currentMode") || "";
                            } else {
                                currentMode = mode;
                                window.localStorage.setItem("currentMode", mode);
                            }
                        }
                    } catch (e) {
                        ;
                    }
                }
                let requestMode = currentMode;
                if (currentMode.indexOf("Android") >= 0) {
                    requestMode = "Android";
                }
                // user-device 偶发 500 时绝不能抛穿：否则 loading 永不结束，AuthGuard 永久转圈（表现为卡死）
                let deviceList = [];
                let deviceFetchFailed = false;
                try {
                    const query = requestMode ? {
                        platform_type: requestMode
                    } : {};
                    const allUserDevice = await (0,login.getAllUserDevice)(query);
                    deviceList = Array.isArray(allUserDevice === null || allUserDevice === void 0 ? void 0 : allUserDevice.data) ? allUserDevice.data : [];
                } catch (e1) {
                    deviceFetchFailed = true;
                    ;
                    const cached = readJson("allDeviceUser", []);
                    deviceList = Array.isArray(cached) ? cached : [];
                }
                if (deviceList.length > 0) {
                    var ref, ref1;
                    // 当前设备：优先按 id 匹配。同一个 iCloud 邮箱可以绑多台设备，
                    // 只按 platform_type 取第一个会在刷新时选错账号（侧栏出现两个选中态）。
                    const pickId = function() {
                        for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++){
                            values[_key] = arguments[_key];
                        }
                        for (const value of values){
                            const id = value == null ? "" : String(value).trim();
                            if (id !== "" && !id.includes("@")) return id;
                        }
                        return "";
                    };
                    const previousDeviceUser = readJson("DeviceUser", null) || {};
                    const previousCurrentDevice = readJson("currentDevice", null) || {};
                    const preferredId = pickId(previousDeviceUser === null || previousDeviceUser === void 0 ? void 0 : previousDeviceUser.device_id, previousDeviceUser === null || previousDeviceUser === void 0 ? void 0 : previousDeviceUser.id, previousCurrentDevice === null || previousCurrentDevice === void 0 ? void 0 : (ref = previousCurrentDevice.DeviceUser) === null || ref === void 0 ? void 0 : ref.device_id, previousCurrentDevice === null || previousCurrentDevice === void 0 ? void 0 : (ref1 = previousCurrentDevice.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.id);
                    var _id, ref2;
                    const deviceIdOf = (row)=>row == null ? "" : String((ref2 = (_id = row.id) !== null && _id !== void 0 ? _id : row.device_id) !== null && ref2 !== void 0 ? ref2 : "").trim();
                    let getCurrentDev = (preferredId ? deviceList.find((row)=>{
                        return deviceIdOf(row) === preferredId && (!currentMode || (row === null || row === void 0 ? void 0 : row.platform_type) === currentMode);
                    }) : null) || deviceList.find((row)=>row.platform_type == currentMode);
                    let currentDevice = readJson("currentDevice", null) || "";
                    if (currentMode == "Android-Local" && currentDevice) {
                        let find = deviceList.find((row)=>row.platform_type == currentMode && row.iCloud_username == currentDevice.id);
                        if (find) {
                            getCurrentDev = find;
                        }
                    }
                    // 与 SpyX 一致：只恢复仍可选（active/grace）的设备，永不自动选中超 30 天失效设备。
                    // 上次用的设备若已过期超 30 天，先回退到同平台其它可选设备；一个都没有则清空选中，
                    // 避免出现「侧栏列表里已隐藏、却仍是当前设备」的幽灵选中态。
                    if (getCurrentDev && !(0,subscriptionStatus/* isSelectableDevice */.He)(getCurrentDev)) {
                        getCurrentDev = (0,subscriptionStatus/* pickPreferredSelectableDevice */.oT)(deviceList, currentMode) || null;
                        if (!getCurrentDev) {
                            localStorage.setItem("DeviceUser", JSON.stringify({}));
                        }
                    }
                    if (getCurrentDev && !(0,resolveCurrentOrderId/* isUnboundPackageSelectionActive */.gJ)()) {
                        // 必须写完整字段（含 device_id）：漏掉 device_id 后所有「按 id 找当前设备」
                        // 的逻辑只能退回用邮箱反查，同邮箱多账号就会串号。
                        // 但侧栏已选中「未绑定的 Package」时不能覆盖：否则刷新后 Package 卡与账号卡
                        // 会同时是选中态，功能菜单也会莫名冒出来。
                        localStorage.setItem("DeviceUser", JSON.stringify((0,subscriptionExpire/* buildDeviceUserPayload */.l)(getCurrentDev)));
                    }
                    const deviceUser = readJson("DeviceUser", {}) || {};
                    if (!deviceUser.username || !deviceUser.password) {
                        localStorage.setItem("Basic", 0);
                    } else {
                        localStorage.setItem("Basic", 1);
                    }
                    localStorage.setItem("BasicTips", 1);
                    localStorage.setItem("Advanced", 1);
                    localStorage.setItem("allDeviceUser", JSON.stringify(deviceList));
                } else if (!deviceFetchFailed) {
                    // 接口成功但无设备：才清本地标记。接口失败时保留原状态，避免偶发 500 把用户打回未绑定。
                    localStorage.setItem("BasicTips", 0);
                    localStorage.setItem("Basic", 0);
                    localStorage.setItem("Advanced", 0);
                    localStorage.setItem("allDeviceUser", JSON.stringify([]));
                }
                user.role = "admin";
                setUser(user);
                window.localStorage.setItem("userData", JSON.stringify(user));
            } catch (e2) {
                ;
                // getUserInfo 等关键路径失败时，尽量用本地缓存顶住，避免 AuthGuard 永久转圈
                const cachedUser = readJson("userData", null);
                if (cachedUser && typeof cachedUser === "object") {
                    cachedUser.role = cachedUser.role || "admin";
                    setUser(cachedUser);
                }
            } finally{
                setLoading(false);
            }
        };
        initAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleLogin = (params, errorCallback)=>{};
    const handleLogout = ()=>{
        setUser(null);
        window.localStorage.removeItem("userData");
        window.localStorage.removeItem(auth.storageTokenKeyName);
        localStorage.removeItem("Basic");
        localStorage.removeItem("Advanced");
        localStorage.removeItem("DeviceUser");
        localStorage.removeItem("currentDevice", JSON.stringify({}));
        (0,utils_navigate/* replaceWith */.dL)("".concat(clientURL, "/login?q=clear"));
    };
    const values = {
        user,
        loading,
        setUser,
        setLoading,
        login: handleLogin,
        logout: handleLogout
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthContext.Provider, {
        value: values,
        children: children
    });
};



/***/ }),

/***/ 32870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ clearBindOrderContext; },
/* harmony export */   "Bq": function() { return /* binding */ guardAppSetupOrderId; },
/* harmony export */   "Ef": function() { return /* binding */ cacheBindOrder; },
/* harmony export */   "G4": function() { return /* binding */ readCachedBindOrderId; },
/* harmony export */   "Gp": function() { return /* binding */ selectUnboundPackage; },
/* harmony export */   "O7": function() { return /* binding */ resolveBindOrderIdWithFeedback; },
/* harmony export */   "Rb": function() { return /* binding */ appendSetupQuery; },
/* harmony export */   "Sj": function() { return /* binding */ ensureBindOrderContext; },
/* harmony export */   "gJ": function() { return /* binding */ isUnboundPackageSelectionActive; }
/* harmony export */ });
/* unused harmony exports persistBindOrderIdFromSearch, syncOrderIdToUrl, isFromAppSession */
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29143);
/* harmony import */ var src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99518);
/* harmony import */ var src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83989);




const BIND_ORDER_STORAGE_KEY = "ontBindOrder";
const FROM_APP_STORAGE_KEY = "spyx_from_app";
const MISSING_ORDER_MSG = "Current order is missing";
const readSearchParams = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    try {
        const raw = String(search || "");
        const query = raw.startsWith("?") ? raw.slice(1) : raw;
        if (!query) return new URLSearchParams();
        return new URLSearchParams(query);
    } catch (e) {
        return new URLSearchParams();
    }
};
const readOrderIdFromSearch = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    try {
        const params = readSearchParams(search);
        const orderId = params.get("orderId") || params.get("order_id");
        return orderId ? String(orderId) : null;
    } catch (e) {
        return null;
    }
};
/** URL 带 orderId 时写入 ontBindOrder；App 会话标记 from_app */ const persistBindOrderIdFromSearch = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] :  true ? window.location.search : 0;
    if (false) {}
    const params = readSearchParams(search);
    if (params.get("from_app") === "1") {
        localStorage.setItem(FROM_APP_STORAGE_KEY, "1");
    }
    const orderId = readOrderIdFromSearch(search);
    if (!orderId) return null;
    try {
        const prev = JSON.parse(localStorage.getItem(BIND_ORDER_STORAGE_KEY) || "null");
        if (prev && typeof prev === "object" && String(prev.id) === String(orderId)) {
            return orderId;
        }
    } catch (e) {
    // ignore invalid cache
    }
    localStorage.setItem(BIND_ORDER_STORAGE_KEY, JSON.stringify({
        id: orderId
    }));
    return orderId;
};
const readCachedBindOrderId = ()=>{
    if (false) {}
    try {
        const ontBindOrder = JSON.parse(localStorage.getItem(BIND_ORDER_STORAGE_KEY) || "null");
        return (ontBindOrder === null || ontBindOrder === void 0 ? void 0 : ontBindOrder.id) ? String(ontBindOrder.id) : null;
    } catch (e) {
        return null;
    }
};
/** 侧栏已选空 Package（有绑定单且无当前设备） */ const isUnboundPackageSelectionActive = ()=>{
    if (false) {}
    const orderId = readCachedBindOrderId();
    if (!orderId) return false;
    try {
        const deviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "{}") || {};
        const hasDevice = deviceUser.device_id != null && String(deviceUser.device_id) !== "" || deviceUser.username != null && String(deviceUser.username) !== "";
        return !hasDevice;
    } catch (e) {
        return true;
    }
};
/** 清除绑定单缓存与 URL 上的 orderId（已绑完 / 失效时用） */ const clearBindOrderContext = ()=>{
    if (false) {}
    try {
        localStorage.removeItem(BIND_ORDER_STORAGE_KEY);
    } catch (e) {
    // ignore
    }
    try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has("orderId") && !url.searchParams.has("order_id")) return;
        url.searchParams.delete("orderId");
        url.searchParams.delete("order_id");
        window.history.replaceState(window.history.state, "", url.toString());
    } catch (e1) {
    // ignore
    }
};
const getBindOrderId = (order)=>{
    var ref;
    const id = (ref = order === null || order === void 0 ? void 0 : order.id) !== null && ref !== void 0 ? ref : order === null || order === void 0 ? void 0 : order.order_id;
    return id != null && id !== "" ? String(id) : null;
};
/** 用户选中套餐后写入 ontBindOrder */ const cacheBindOrder = (order)=>{
    if (false) {}
    const id = getBindOrderId(order);
    if (!id) return null;
    localStorage.setItem(BIND_ORDER_STORAGE_KEY, JSON.stringify({
        ...order,
        id
    }));
    return id;
};
/**
 * 侧栏选中空 Package：写入绑定单、清空当前设备选中并广播切换。
 * 使 Redux / localStorage 与 UI 高亮一致，不再保留上一个已绑定设备。
 */ const selectUnboundPackage = (param)=>{
    let { dispatch , order  } = param;
    const orderId = cacheBindOrder(order);
    if (!orderId) return null;
    syncOrderIdToUrl(orderId);
    (0,src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_3__/* .switchDevice */ .m)({
        dispatch,
        deviceUser: {},
        currentDevice: {}
    });
    return orderId;
};
/** 无刷新把 orderId 同步到地址栏，避免刷新丢上下文 */ const syncOrderIdToUrl = (orderId)=>{
    if ( false || !orderId) return;
    try {
        const url = new URL(window.location.href);
        if (url.searchParams.get("orderId") === String(orderId)) return;
        url.searchParams.set("orderId", String(orderId));
        url.searchParams.delete("order_id");
        window.history.replaceState(window.history.state, "", url.toString());
    } catch (e) {
    // ignore
    }
};
const isFromAppSession = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] :  true ? window.location.search : 0;
    const params = readSearchParams(search);
    if (params.get("from_app") === "1") return true;
    if (false) {}
    return localStorage.getItem(FROM_APP_STORAGE_KEY) === "1";
};
/** 跳转 setup 子页时带上 orderId / from_app */ const appendSetupQuery = (path, orderId)=>{
    if (!path) return path;
    const resolvedOrderId = orderId || readOrderIdFromSearch( true ? window.location.search : 0) || readCachedBindOrderId();
    const fromApp = isFromAppSession( true ? window.location.search : 0);
    if (!resolvedOrderId && !fromApp) return path;
    try {
        const [pathnameAndQuery, hash = ""] = String(path).split("#");
        const qIndex = pathnameAndQuery.indexOf("?");
        const pathname = qIndex >= 0 ? pathnameAndQuery.slice(0, qIndex) : pathnameAndQuery;
        const existing = qIndex >= 0 ? pathnameAndQuery.slice(qIndex + 1) : "";
        const params = new URLSearchParams(existing);
        if (resolvedOrderId) {
            params.set("orderId", String(resolvedOrderId));
            params.delete("order_id");
        }
        if (fromApp) {
            params.set("from_app", "1");
        }
        const qs = params.toString();
        return "".concat(pathname).concat(qs ? "?".concat(qs) : "").concat(hash ? "#".concat(hash) : "");
    } catch (e) {
        return path;
    }
};
/** App 进 setup 必须有 orderId，否则拦截 */ const guardAppSetupOrderId = function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] :  true ? window.location.search : 0;
    const params = readSearchParams(search);
    const queryOrderId = readOrderIdFromSearch(search);
    const fromAppInUrl = params.get("from_app") === "1";
    const fromApp = isFromAppSession(search);
    if (fromAppInUrl && !queryOrderId) {
        (0,src_components_Message__WEBPACK_IMPORTED_MODULE_1__/* .messageInfo */ .B)({
            content: MISSING_ORDER_MSG
        });
        return {
            ok: false,
            blocked: true,
            orderId: null,
            fromApp: true
        };
    }
    const persisted = persistBindOrderIdFromSearch(search);
    const orderId = persisted || queryOrderId || readCachedBindOrderId();
    if (fromApp && !orderId) {
        (0,src_components_Message__WEBPACK_IMPORTED_MODULE_1__/* .messageInfo */ .B)({
            content: MISSING_ORDER_MSG
        });
        return {
            ok: false,
            blocked: true,
            orderId: null,
            fromApp: true
        };
    }
    return {
        ok: true,
        blocked: false,
        orderId,
        fromApp
    };
};
let unboundOrdersInflight = null;
const loadUnboundOrders = async ()=>{
    if (unboundOrdersInflight) return unboundOrdersInflight;
    unboundOrdersInflight = (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getNotBindOrder)().then((res)=>{
        return Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
    }).finally(()=>{
        setTimeout(()=>{
            unboundOrdersInflight = null;
        }, 2000);
    });
    return unboundOrdersInflight;
};
/**
 * 从未绑单列表解析 orderId（购买 → 绑定主路径）
 * - 过滤过期单后仅 1 张有效未绑单：自动选中
 * - 多张有效单：优先侧栏已选缓存；setup 初始化时可 autoPickFirst 默认第一张
 */ const resolveFromUnboundOrders = function(unbound) {
    let { autoPickFirst =false  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const list = (0,src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_2__/* .filterValidUnboundOrders */ .tA)(unbound);
    if (list.length === 1) {
        return cacheBindOrder(list[0]);
    }
    if (list.length > 1) {
        const selected = readCachedBindOrderId();
        if (selected && list.some((item)=>getBindOrderId(item) === selected)) {
            return selected;
        }
        if (autoPickFirst) {
            return cacheBindOrder(list[0]);
        }
    }
    return null;
};
/**
 * setup 页初始化：同步 URL/cache；仅一张未绑单时自动挂上 orderId
 */ const ensureBindOrderContext = async function() {
    let search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] :  true ? window.location.search : 0;
    const guard = guardAppSetupOrderId(search);
    if (guard.blocked) {
        return {
            ...guard,
            needsOrderSelection: false
        };
    }
    let orderId = guard.orderId;
    let needsOrderSelection = false;
    if (!orderId) {
        try {
            const unbound = await loadUnboundOrders();
            orderId = resolveFromUnboundOrders(unbound, {
                autoPickFirst: true
            });
            if (orderId) {
                syncOrderIdToUrl(orderId);
            } else if ((0,src_utils_chooseDeviceRedirect__WEBPACK_IMPORTED_MODULE_2__/* .filterValidUnboundOrders */ .tA)(unbound).length > 1) {
                needsOrderSelection = true;
            }
        } catch (e) {
            ;
        }
    } else {
        syncOrderIdToUrl(orderId);
    }
    return {
        ok: true,
        blocked: false,
        orderId,
        fromApp: guard.fromApp,
        needsOrderSelection
    };
};
/** Connect 点击时解析 orderId，失败则 toast */ const resolveBindOrderIdWithFeedback = async function(t) {
    let notify = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : src_components_Message__WEBPACK_IMPORTED_MODULE_1__/* .messageInfo */ .B;
    try {
        const orderId = await resolveCurrentOrderId();
        if (!orderId) {
            notify({
                content: (t === null || t === void 0 ? void 0 : t("Please select a package to bind first")) || MISSING_ORDER_MSG,
                type: "error"
            });
            return null;
        }
        return orderId;
    } catch (e) {
        notify({
            content: (t === null || t === void 0 ? void 0 : t("Network error, please try again")) || "Network error, please try again",
            type: "error"
        });
        return null;
    }
};
/**
 * 绑定 API 用的 order_id（字段名必须是 order_id，不是 orderId）
 * 优先级：显式传入 → URL/缓存 → 未绑单 → 已有设备/支付单号
 */ const resolveCurrentOrderId = async function() {
    let { order , orderId  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (orderId) return String(orderId);
    if (order === null || order === void 0 ? void 0 : order.id) return String(order.id);
    const fromUrl = persistBindOrderIdFromSearch( true ? window.location.search : 0);
    if (fromUrl) return fromUrl;
    const cached = readCachedBindOrderId();
    if (cached) return cached;
    try {
        const unbound = await loadUnboundOrders();
        const fromUnbound = resolveFromUnboundOrders(unbound, {
            autoPickFirst: true
        });
        if (fromUnbound) {
            syncOrderIdToUrl(fromUnbound);
            return fromUnbound;
        }
    } catch (e) {
        ;
        throw e;
    }
    let deviceUser = null;
    try {
        deviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "null");
    } catch (e1) {
    // ignore invalid DeviceUser
    }
    let orders = null;
    const loadAccountOrders = async ()=>{
        if (orders) return orders;
        const query = {
            page: 1,
            pageSize: 9999
        };
        try {
            const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getUserAccountOrder)(query);
            orders = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
            return orders;
        } catch (e) {
            ;
            throw e;
        }
    };
    // 已有设备重验：按 device_id 找关联订单
    if (deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.device_id) {
        const list = await loadAccountOrders();
        const byDevice = list.find((item)=>String(item.device_id) === String(deviceUser.device_id));
        if (byDevice === null || byDevice === void 0 ? void 0 : byDevice.id) return String(byDevice.id);
    }
    // 支付回调写入的 orderNo
    const orderNo = localStorage.getItem("orderNo");
    if (orderNo) {
        const list1 = await loadAccountOrders();
        const byMerchant = list1.find((item)=>String(item.merchant_no) === String(orderNo));
        if (byMerchant === null || byMerchant === void 0 ? void 0 : byMerchant.id) return String(byMerchant.id);
    }
    return null;
};
/* harmony default export */ __webpack_exports__["ZP"] = (resolveCurrentOrderId);


/***/ }),

/***/ 83989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ switchDevice; }
/* harmony export */ });
/* unused harmony export resolveDeviceUserId */
/* harmony import */ var src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38365);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34745);
/* harmony import */ var src_utils_deviceContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67778);



/** 切换设备时需清除的会话级 localStorage 缓存 */ const DEVICE_SCOPED_CACHE_KEYS = [
    "smsItem",
    "whatsappItem",
    "lineItem",
    "kikItem",
    "weChatItem",
    "MessengerItem",
    "messengerItem",
    "wechatItem",
    "waBusinessItem",
    "androidWhatsappItem"
];
/**
 * 从 DeviceUser 解析 Redux 选中键（优先 device_id，否则 username）。
 * @param {Object} [deviceUser]
 * @returns {string}
 */ const resolveDeviceUserId = (deviceUser)=>{
    if (!deviceUser) return "";
    return deviceUser.device_id != null && deviceUser.device_id !== "" ? String(deviceUser.device_id) : deviceUser.username || "";
};
/**
 * 统一设备切换入口：写 localStorage、清会话缓存、广播 deviceSwitched、刷新验证/连接状态。
 * 超 30 天失效设备禁止成为选中态。
 * @param {Object} params
 * @param {import('redux').Dispatch} params.dispatch
 * @param {Object} [params.deviceUser] - 写入 DeviceUser；undefined 时不覆盖
 * @param {Object} [params.currentDevice] - 写入 currentDevice；undefined 时不覆盖
 * @param {string} [params.currentMode] - 平台模式；缺省读 localStorage
 * @param {boolean} [params.skipSelectionGuard] - 仅清空/非选中场景跳过校验
 * @returns {ReturnType<import('src/utils/deviceContext').buildDeviceContext}|null}
 */ const switchDevice = (param)=>{
    let { dispatch , deviceUser , currentDevice , currentMode , skipSelectionGuard =false  } = param;
    const hasSelectionPayload = deviceUser !== undefined && deviceUser != null && typeof deviceUser === "object" && Object.keys(deviceUser).length > 0;
    if (!skipSelectionGuard && hasSelectionPayload) {
        const check = (0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_0__/* .validateDeviceSelection */ .dv)(deviceUser);
        if (!check.ok) {
            ;
            return null;
        }
    }
    const mode = currentMode !== undefined && currentMode !== null && currentMode !== "" ? currentMode : localStorage.getItem("currentMode") || "";
    // 先写 currentMode，再 dispatch，避免其它逻辑读到旧平台
    if (mode) {
        localStorage.setItem("currentMode", mode);
    }
    if (deviceUser !== undefined) {
        localStorage.setItem("DeviceUser", JSON.stringify(deviceUser));
    }
    if (currentDevice !== undefined) {
        localStorage.setItem("currentDevice", JSON.stringify(currentDevice));
    }
    DEVICE_SCOPED_CACHE_KEYS.forEach((key)=>localStorage.removeItem(key));
    const deviceId = resolveDeviceUserId(deviceUser);
    const storedDeviceUser = deviceUser !== undefined ? deviceUser : JSON.parse(localStorage.getItem("DeviceUser") || "{}");
    const storedCurrentDevice = currentDevice !== undefined ? currentDevice : JSON.parse(localStorage.getItem("currentDevice") || "{}");
    const deviceContext = (0,src_utils_deviceContext__WEBPACK_IMPORTED_MODULE_2__/* .buildDeviceContext */ .D$)({
        deviceUser: storedDeviceUser,
        currentDevice: storedCurrentDevice,
        currentMode: mode,
        switchToken: (0,src_utils_deviceContext__WEBPACK_IMPORTED_MODULE_2__/* .createSwitchToken */ .kb)()
    });
    localStorage.setItem("deviceContext", JSON.stringify(deviceContext));
    dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .deviceSwitched */ .ex)({
        deviceUserId: deviceId,
        currentMode: mode,
        deviceContext
    }));
    dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .fetchResetTime */ .NZ)());
    if (mode === "Android-Local") {
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .getConnectionStatus */ .Zp)());
    } else {
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .setConnectionStatus */ .bl)(false));
    }
    return deviceContext;
};


/***/ })

}]);